const textFieldConfirmCreateUser = {
  name: 'Full name',
  helperText: 'Enter your full name',
  email: 'Email',
  password: 'Password',
  helperTextPassword: 'Minimum of 6 characters',
  confirmPassword: 'Confirm your password',
  helperTextConfirmPassword: 'Different passwords'
};

export default textFieldConfirmCreateUser;
